import React, { useState } from 'react';
import { Headphones } from 'lucide-react';
import { getLanguage } from '../i18n';
import { isTtsAutoplayEnabled, setTtsAutoplayEnabled } from '../services/TtsPreferenceService';
import './ReadingAudioControls.css';
export const readingAudioText = (ko, en) => getLanguage() === 'ko' ? ko : en;
export default function ReadingAudioControls({ audio, canUseTts = true, onMembershipRequired, onAutoplayEnabledChange, showAutoplayToggle = true }) {
  const [auto, setAuto] = useState(isTtsAutoplayEnabled);
  const { engine, state } = audio;
  const toggleAutoplay = () => {
    if (!canUseTts) { onMembershipRequired?.(); return; }
    const enabled = setTtsAutoplayEnabled(!auto);
    setAuto(enabled);
    onAutoplayEnabledChange?.(enabled);
  };
  const retry = () => {
    if (!canUseTts) onMembershipRequired?.();
    else void engine?.resume();
  };
  const title = !canUseTts ? readingAudioText('멤버십 듣기', 'Membership listening')
    : auto ? readingAudioText('답 자동 듣기 끄기', 'Turn automatic listening off')
      : readingAudioText('답 자동 듣기 켜기', 'Turn automatic listening on');
  if (!showAutoplayToggle && !['error', 'blocked'].includes(state.status)) return null;
  return <div className="reading-audio-controls" onClick={event => event.stopPropagation()}>
      {showAutoplayToggle && <button type="button" className={`reading-audio-play ${auto ? 'is-on' : 'is-off'}`} onClick={toggleAutoplay} aria-pressed={auto} aria-label={title} title={title}>
        <Headphones size={18} aria-hidden="true" />
      </button>}
    {['error', 'blocked'].includes(state.status) && <button type="button" className="reading-audio-error" onClick={retry} role="status">
      {state.status === 'blocked' ? readingAudioText('탭하여 재생', 'Tap to play') : state.error === 'changed' ? readingAudioText('내용이 변경되었습니다. 탭하여 다시 준비', 'Content changed. Tap to reload') : readingAudioText('음원을 준비하지 못했습니다. 탭하여 재시도', 'Audio unavailable. Tap to retry')}
    </button>}
  </div>;
}
